module.exports = "/OhNeinActive@2x-069a3ac6738908251b5328aa0da7296e.png";